import Modal from './Modal';
import MessageBox from './MessageBox';
import Mobile from './Mobile';
import Copy from './Copy';
import Forms from './Forms';

import YouTubePlayer, { YouTubeAPI, YouTubePlayerHelper } from './YouTubePlayer';

const BASE_HELPERS = {
    Modal,
    MessageBox,
    Mobile,
    Copy,
    Forms,
    YouTubePlayer,
    YouTubeAPI,
    YouTubePlayerHelper,
};

if (typeof window !== 'undefined') {
    window.BASE_HELPERS = BASE_HELPERS;
}

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => Copy.initCopy(), { once: true });
    } else {
        Copy.initCopy();
    }
}

export default BASE_HELPERS;
export {
    Modal,
    MessageBox,
    Mobile,
    Copy,
    Forms,
    YouTubePlayer,
    YouTubeAPI,
    YouTubePlayerHelper,
};
